import { Link } from '@mui/material';
import { PackageGroup } from '../../store/config/types';
import { getPackageGroupLabel } from '../../utils/deliveryOrders.helpers';

interface PackageGroupLinkProps {
  packageGroup: PackageGroup;
}
export default function PackageGroupLink({ packageGroup }: PackageGroupLinkProps) {
  const idLabel = getPackageGroupLabel(packageGroup);
  const idLink = packageGroup.additionalData?.externalLink ? (
    <Link href={packageGroup.additionalData?.externalLink} target="_blank">
      {idLabel}
    </Link>
  ) : (
    <span>{idLabel}</span>
  );
  return (
    <span style={{ whiteSpace: 'nowrap' }} key={`id-${packageGroup.packageGroupId}`}>
      {idLink}
    </span>
  );
}
